import type { ReactNode } from "react";
import { adminFormGridClass, adminFormSectionTitleClass } from "./adminStyles";

type AdminFormSectionProps = {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
  columns?: "1" | "2" | "3";
};

const columnClasses = {
  "1": "grid grid-cols-1 gap-6 w-full",
  "2": "grid grid-cols-1 gap-6 sm:grid-cols-2 w-full",
  "3": adminFormGridClass,
};

export default function AdminFormSection({
  title,
  description,
  children,
  className = "",
  columns = "3",
}: AdminFormSectionProps) {
  return (
    <section className={`w-full ${className}`.trim()}>
      <div className="mb-5 border-b border-gray-200 pb-4 dark:border-gray-800">
        <h3 className={adminFormSectionTitleClass}>{title}</h3>
        {description && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
        )}
      </div>
      <div className={columnClasses[columns]}>{children}</div>
    </section>
  );
}
